import { Star, ShieldCheck, Clock, CreditCard } from "lucide-react";

const ITEMS = [
  { icon: Star, title: "5.0 star rated", sub: "Loved by Melbourne riders" },
  { icon: ShieldCheck, title: "CPV accredited", sub: "Licensed & fully insured" },
  { icon: Clock, title: "24/7 dispatch", sub: "Every day of the year" },
  { icon: CreditCard, title: "Metered rates", sub: "No surge, no surprises" },
];

export function TrustRow() {
  return (
    <section className="grid grid-cols-2 gap-3 rounded-xl border border-border/60 bg-card p-4 md:grid-cols-4 md:p-6">
      {ITEMS.map((it) => (
        <div key={it.title} className="flex items-center gap-3">
          <it.icon className="h-5 w-5 shrink-0 text-primary" />
          <div className="leading-tight">
            <div className="text-xs font-bold tracking-wide">{it.title}</div>
            <div className="text-[11px] text-muted-foreground">{it.sub}</div>
          </div>
        </div>
      ))}
    </section>
  );
}